<template>
  <div class="Programming-View">
    <div>
      <div>
        <div>
          <div class="desc" :style="
            this.currQuestion._cls === 'Programming' ? 'width: 100%' : ''
          " v-html="currQuestion.description">
            <!-- {{ currQuestion.description }}. -->
          </div>
          <!-- Below line kept for testing -->
          <!-- <span class="math-tex">( \(\frac{2}{7},\frac{2}{20}\) )</span> -->
        </div>
      </div>
      <div style="margin-top: 9px">
        <div class="constraints" style="background: #f2f2f2">
          <div class="constraint-property" style="width: 109px">Time Limit</div>
          <div class="constraint-property" style="font-family: Roboto-Regular; margin-left: 12px">
            {{ this.currQuestion.settings.time_limit }} sec(s) for each input
            file
          </div>
        </div>
        <div class="constraints">
          <div class="constraint-property" style="width: 109px">
            Memory Limit
          </div>
          <div class="constraint-property" style="font-family: Roboto-Regular; margin-left: 12px">
            {{ this.currQuestion.settings.memory_limit }} KB
          </div>
        </div>
        <!--<div class="constraints" style="background: #F2F2F2;">
          <div class="constraint-property" style="width: 109px">
            Source Limit
          </div>
          <div
            class="constraint-property"
            style="font-family: Roboto-Regular;margin-left: 12px"
          >
            {{ this.currQuestion.settings.source_limit }} KB
          </div>
        </div>-->
        <div class="constraints" style="background: #f2f2f2">
          <div class="constraint-property" style="width: 109px">
            Allowed Languages
          </div>
          <div class="constraint-property" style="font-family: Roboto-Regular; margin-left: 12px">
            {{ getLangauges }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Programming',
  props: ['currQuestion'],
  computed: {
    getLangauges() {
      var str = ''
      for (const lan in this.currQuestion.settings.allowed_languages) {
        if (lan === '0') {
          str += this.currQuestion.settings.allowed_languages[lan]
        } else {
          str += ', ' + this.currQuestion.settings.allowed_languages[lan]
        }
      }
      return str
    },
  },
  mounted() {
    this.$nextTick(function () {
      // Use the below for MathJax version <3
      // MathJax.Hub.Queue(["Typeset", MathJax.Hub, document.body])

      // For MathJax version 3.0 and above use below
      MathJax.typeset();
    });
  },
  updated() {
    MathJax.typeset();
  },

}
</script>

<style scoped>
.sample-input-output {
  display: flex;
  margin-top: 16px;
}

.sample-header {
  background: #eeeeee;
  font-family: Roboto-Bold;
  font-size: 14px;
  color: #69758b;
  padding: 12px 32px 12px 24px;
  border: 1px solid #d9d9d9;
}

.sample-io-content {
  border: 1px solid #d9d9d9;
  border-top: none;
  padding: 16px 32px 16px 24px;
}

.explanation-heading {
  font-family: Roboto-Bold;
  font-size: 14px;
  color: #343c4b;
  line-height: 20px;
}

.explanation {
  margin-top: 52px;
}

.explanation-content {
  font-family: Roboto-Regular;
  font-size: 14px;
  color: #343c4b;
  line-height: 20px;
}

.constraints {
  display: flex;
}

.constraint-property {
  font-family: Roboto-Medium;
  font-size: 12px;
  color: #343c4b;
  margin: 8px 0px 8px 16px;
}

.block {
  border: none !important;
  font-size: 16px !important;
}

.block .ql-editor {
  padding: 0px 0px !important;
}

/*ToDo: Change background color of sample test-cases*/
.block .ql-editor .desc .ql-syntax {
  background-color: #e7eeef !important;
}

@media only screen and (max-width: 1440px) {
  .block {
    font-size: 14px !important;
  }
}
</style>
